<template>
  <transition name="slide-up">
    <div v-if="isOpen">
      <div class="w-full h-full bg-[#ffffff]/20 backdrop-blur-[35px] fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-50"></div>
      <slot />
    </div>
  </transition>
</template>

<script setup>
defineProps(['isOpen']);
</script>

